<template>
  <el-container class="outer">
    <div class="loginContainer">
      <el-card>
        <div class="title" ref="title">{{ $t('LOGIN_loginTitle') }}</div>

        <transition name="fade" mode="out-in">
          <!-- FORMULARIO LOGIN -->
          <el-form key="loginForm" :model="loginForm" v-if="formToShow === 'LOGIN'">
            <el-form-item :error="loginErrors['usuario']" class="custom-error">
              <el-input
                :placeholder="$t('LOGIN_user')"
                prefix-icon="el-icon-user"
                v-model="loginForm.usuario"
              />
            </el-form-item>

            <el-form-item :error="loginErrors['contrasenia']" class="custom-error">
              <el-input
                :placeholder="$t('LOGIN_password')"
                prefix-icon="el-icon-lock"
                show-password
                v-model="loginForm.contrasenia"
                v-on:keyup.enter.native="onIngresar"
              />
            </el-form-item>

            <el-form-item class="botonContainer">
              <el-button
                v-on:click="onIngresar"
                :loading="sesion.autenticando"
                plain
                type="primary"
                style=" color:white !important;"
              >{{ $t('LOGIN_loginBtn') }}</el-button>
            </el-form-item>

            <el-form-item>
              <el-link
                style="color:white;"
                :underline="false"
                @click="formToShow = 'RESTABLECER_CONTRASENIA'"
              >{{ $t('LOGIN_forgotPassword') }}</el-link>
            </el-form-item>
          </el-form>

          <!-- FORMULARIO OLVIDÉ CONTRASEÑA -->
          <el-form
            key="resetPasswordForm"
            class="resetPassword"
            v-if="formToShow === 'RESTABLECER_CONTRASENIA'"
          >
            <p class="restablecerMessage" style="color:white">{{ $t('LOGIN_resetPasswordMsg') }}</p>

            <el-form-item :error="resetPasswordErrors['usuario']" class="custom-error">
              <div class="usuarioLabel">{{ $t('LOGIN_user') }}</div>
              <!-- <el-radio :label="'usuario'" v-model="resetPasswordForm.campoChequeado">{{ $t('LOGIN_user') }}</el-radio> -->
              <el-input
                v-model="resetPasswordForm.usuario"
                :disabled="resetPasswordForm.campoChequeado !== 'usuario'"
              />
            </el-form-item>

            <!-- <el-form-item :error="resetPasswordErrors['email']">
              <el-radio :label="'email'" v-model="resetPasswordForm.campoChequeado">{{ $t('LOGIN_email') }}</el-radio>
              <el-input v-model="resetPasswordForm.email" :disabled="resetPasswordForm.campoChequeado !== 'email'" />
            </el-form-item>-->

            <el-form-item class="botonContainer">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-button
                    type="primary"
                    class="first"
                    v-on:click="onEnviarMail"
                    :loading="sesion.loading"
                    plain
                    style="color:white !important;"
                  >{{ $t('LOGIN_sendButton') }}</el-button>
                </el-col>

                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-button v-on:click="formToShow = 'LOGIN'">{{ $t('GENERAL_cancelBtn') }}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>

          <el-form key="mailPassForm" :model="newPassForm" v-if="formToShow === 'NEW_PASS'">
            <el-form-item :error="newPassErrors['contrasenia']" class="custom-error">
              <el-input
                :placeholder="$t('LOGIN_new_password')"
                prefix-icon="el-icon-lock"
                show-password
                v-model="newPassForm.contrasenia"
              />
            </el-form-item>

            <el-form-item :error="newPassErrors['confirm_contrasenia']" class="custom-error">
              <el-input
                :placeholder="$t('LOGIN_confirm_password')"
                prefix-icon="el-icon-lock"
                show-password
                :disabled="newPassForm.contrasenia === ''"
                v-model="newPassForm.confirm_contrasenia"
                v-on:keyup.enter.native="onConfirmNewPassword"
                @input="onConfirmPasswordInput"
              />
            </el-form-item>

            <el-form-item class="botonContainer">
              <el-row :gutter="20">
                <el-col>
                  <el-button
                    type="primary"
                    @click="onConfirmNewPassword"
                    :loading="sesion.loading"
                    :disabled="this.newPassForm.contrasenia !== this.newPassForm.confirm_contrasenia"
                  >{{ $t('GENERAL_confirmBtn') }}</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>

          <!-- FORMULARIO CAMBIO CONTRASENIA VENCIDA -->
          <el-form key="changePasswordForm" :model="changePasswordForm" v-if="formToShow === 'CHANGE_PASSWORD'">
            <p class="restablecerMessage" style="color:white">{{ $t('LOGIN_expiredPassword') }}</p>
            <el-form-item :error="changePasswordErrors['currentPassword']" class="custom-error">
              <el-input
                :placeholder="$t('LOGIN_password')"
                prefix-icon="el-icon-lock"
                show-password
                v-model="changePasswordForm.currentPassword"
              />
            </el-form-item>

          <el-form-item :error="changePasswordErrors['newPassword']" class="custom-error">
            <el-input
              :placeholder="$t('LOGIN_new_password')"
              prefix-icon="el-icon-lock"
              show-password
              v-model="changePasswordForm.newPassword"
            />
          </el-form-item>

          <el-form-item :error="changePasswordErrors['confirmNewPassword']" class="custom-error">
            <el-input
              :placeholder="$t('LOGIN_confirm_password')"
              prefix-icon="el-icon-lock"
              show-password
              v-model="changePasswordForm.confirmNewPassword"
              v-on:keyup.enter.native="onChangePassword"
            />
          </el-form-item>

          <el-form-item class="botonContainer">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-button
                  @click="onChangePassword"
                  type="primary"
                  :loading="sesion.loading"
                  plain
                  style=" color:white !important;"
                >
                  {{ $t('LOGIN_confirmBtn') }}
                </el-button>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-button @click=onCancelChangePassword>{{ $t('GENERAL_cancelBtn') }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>

        
        <!-- Verificacion TOTP -->
         <el-form key="verifyTOTP" :model="verifyTOTP" v-if="formToShow === 'VERIFY_TOTP'" class="el-form-verifyTOTP-container">
          <p style="color:white">{{ $t('TWO_FACTOR_AUTHENTICATION_message') }}</p>
          <el-row class="verify-section">
                <el-form class="el-form-verifyTOTP" @submit.native.prevent="submitCode">
                    <el-form-item>
                        <input 
                        v-for="(digit, index) in digits"
                        :key="index"
                        ref="inputs"
                        type="text"
                        maxlength="1"
                        class="code-input"
                        v-model="digits[index]"
                        @input="moveToNext(index)"
                        @keydown.backspace="moveToPrev(index)"
                        @keypress="onlyNumbers"
                        @keyup.enter="submitCode"
                        />
                    </el-form-item>
                    <el-button
                      v-on:click="submitCode"
                      :loading="sesion.validandoTOTP"
                      plain
                      type="primary"
                      style=" color:white !important;"
                      >{{ $t('TWO_FACTOR_AUTHENTICATION_verify') }}
                    </el-button>
                </el-form>
            </el-row>
        </el-form>

        </transition>

        <div class="footer">
          <div class="dataFiscalContainer">
            <a href="http://qr.afip.gob.ar/?qr=2fGI8DEy48NDM7k_CLFtdg,," target="_blank">
              <img src="../../images/dataFiscal.png" />
            </a>
          </div>

          <div class="contactoContainer">
            <router-link :to="{ name: 'Info' }">
              <el-link style="color:white;">
                <i class="el-icon-message"></i>
                {{ $t('LOGIN_contact') }}
              </el-link>
            </router-link>
          </div>
        </div>
      </el-card>
    </div>

    <SesionActivaModal
      v-if="showSesionActivaModal"
      :username="loginForm.usuario"
      :sesionActiva="sesionActiva"
      :onCloseModal="() => showSesionActivaModal = false"
    />

  </el-container>
</template>

<script>
import { mapState } from "vuex";
import { showError, showSuccess } from "../Mensaje";
import SesionActivaModal from "./sesionActivaModal";

export default {
  name: "Login",
  components: { SesionActivaModal },
  data() {
    return {
      loginForm: {
        usuario: "",
        contrasenia: ""
      },
      loginErrors: {},
      sesionActiva: undefined,
      showSesionActivaModal: false,

      newPassForm: {
        contrasenia: "",
        confirm_contrasenia: ""
      },
      newPassErrors: {},

      resetPasswordForm: {
        campoChequeado: "usuario",
        usuario: "",
        email: ""
      },
      verifyTOTP:{
        code: "",
        isCodeValid: false
      },
      resetPasswordErrors: {},

      formToShow: this.$route.params.user === undefined ? "LOGIN" : "NEW_PASS",

      showCambioContrasenia: false,
      
      changePasswordForm: {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: ""
    },
    changePasswordErrors: {},
    digits: Array(6).fill("")
    };
  },
  methods: {
    onIngresar() {
      //Scroll para Android
      document.body.scrollTop = 0;
      //Scroll para IOS
      document.documentElement.scrollTop = 0;
      if (this.sesion.autenticando) return;

      // valido el formulario
      let valida = true;
      this.loginErrors = {};

      if (!this.loginForm.usuario) {
        valida = false;
        this.loginErrors["usuario"] = this.$t("GENERAL_requiredField");
      }

      if (!this.loginForm.contrasenia) {
        valida = false;
        this.loginErrors["contrasenia"] = this.$t("GENERAL_requiredField");
      }

      if (!valida) return;

      // autentico el usuario
      let payload = {
        usuario: this.loginForm.usuario,
        contrasenia: this.loginForm.contrasenia
      };
      this.$store.dispatch("sesion/autenticar", payload).then(resultado => {
        if (resultado !== undefined) {
          // si la contrasenia esta vencida
          if (resultado.CodigoResultado === 18) {
            showError(this.$t("LOGIN_expiredPassword"));
            //this.showCambioContrasenia = true;
            this.formToShow = 'CHANGE_PASSWORD';
          }
          else if(resultado.CodigoResultado === 19){
            this.formToShow = 'VERIFY_TOTP';
            this.$refs.title.textContent = this.$t('TWO_FACTOR_AUTHENTICATION_title');
          }
          // si está autenticado redirijo al main
          else if (resultado.EstaAutenticado === true)
            this.$router.push({ name: "Home" });
          // si existe otra sesión activa, muestro el modal
          else if (resultado.CodigoResultado === 15) {
            this.sesionActiva = resultado.Sesion;
            this.showSesionActivaModal = true;
          }

          else showError(this.$t("LOGIN_invalidLogin"));
        } else showError(this.$t("ERROR_CODE_NETWORK"));
      });
    },

    onEnviarMail() {
      // valido el formulario
      let valida = true;
      this.resetPasswordErrors = {};

      if (
        this.resetPasswordForm.campoChequeado === "usuario" &&
        !this.resetPasswordForm.usuario
      ) {
        valida = false;
        this.resetPasswordErrors["usuario"] = this.$t("GENERAL_requiredField");
      }

      if (
        this.resetPasswordForm.campoChequeado === "email" &&
        !this.resetPasswordForm.email
      ) {
        valida = false;
        this.resetPasswordErrors["email"] = this.$t("GENERAL_requiredField");
      }

      if (!valida) return;

      // llamo a la lógica de envío de email
      let payload = {
        usuario:
          this.resetPasswordForm.campoChequeado === "usuario"
            ? this.resetPasswordForm.usuario
            : "",
        email:
          this.resetPasswordForm.campoChequeado === "email"
            ? this.resetPasswordForm.email
            : ""
      };
      this.$store
        .dispatch("sesion/recuperarContrasenia", payload)
        .then(response => {
          if (response === 0) {
            showSuccess(this.$t("RETRIEVE_PASS_emailSent"));
            this.formToShow = "LOGIN";
          } else showError(this.$t("ERROR_CODE_AUTH_" + response));
        });
    },
    onConfirmPasswordInput(value) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (value !== "") {
        this.timer = setTimeout(() => {
          if (
            this.newPassForm.contrasenia !==
            this.newPassForm.confirm_contrasenia
          )
            this.$set(
              this.newPassErrors,
              "confirm_contrasenia",
              this.$t("LOGIN_password_mismatch")
            );
          else this.$set(this.newPassErrors, "confirm_contrasenia", "");
        }, 500);
      } else this.$set(this.newPassErrors, "confirm_contrasenia", "");
    },
    onConfirmNewPassword() {
      let valida = true;
      this.newPassErrors = {};

      if (!this.newPassForm.contrasenia) {
        valida = false;
        this.newPassErrors.contrasenia = this.$t("GENERAL_requiredField");
      }

      if (!this.newPassForm.confirm_contrasenia) {
        valida = false;
        this.newPassErrors.confirm_contrasenia = this.$t(
          "GENERAL_requiredField"
        );
      }

      if (this.newPassForm.contrasenia !== this.newPassForm.confirm_contrasenia)
        valida = false;

      if (!valida) return;

      let payload = {
        nombreUsuario: this.$route.params.user,
        token: this.$route.params.code,
        contrasenia: this.newPassForm.contrasenia
      };
      this.$store
        .dispatch("sesion/restablecerContrasenia", payload)
        .then(resultado => {
          if (resultado == 0) {
            showSuccess(this.$t("ERROR_CODE_AUTH_0"));
            this.formToShow = "LOGIN";
          } else {
            showError(this.$t("ERROR_CODE_AUTH_" + resultado));
          }
        });
    },
    
    onChangePassword() {
      // Validar campos
      this.changePasswordErrors = {};
      let isValid = true;

      if (!this.changePasswordForm.currentPassword) {
        isValid = false;
        this.changePasswordErrors['currentPassword'] = this.$t('GENERAL_requiredField');
      }

      if (!this.changePasswordForm.newPassword) {
        isValid = false;
        this.changePasswordErrors['newPassword'] = this.$t('GENERAL_requiredField');
      }
      if (!this.changePasswordForm.confirmNewPassword) {
        isValid = false;
        this.changePasswordErrors['confirmNewPassword'] = this.$t('GENERAL_requiredField');
      }

      else if (
        this.changePasswordForm.newPassword !==
        this.changePasswordForm.confirmNewPassword
      ) {
        isValid = false;
        this.changePasswordErrors['confirmNewPassword'] = this.$t('CHANGE_PASS_passwordNotEquals');
      }

      if (!isValid) return;

      // Lógica para cambiar la contraseña
      const payload = {
        usuario: this.loginForm.usuario,
        contraseniaActual: this.changePasswordForm.currentPassword,
        contraseniaNueva: this.changePasswordForm.newPassword
      };
      
      this.$store.dispatch('sesion/cambiarContraseniaVencida', payload)
        .then((data) => {
          // indico que se terminó de cambiar la contraseña
          if(data === undefined)
            return

          // éxito
          if(data === 0)
          {
            // muestro mensaje y cierro la modal
            showSuccess(this.$t('CHANGE_PASS_changePasswordSuccess'))
            this.loginForm.usuario = ''
            this.loginForm.contrasenia = ''
            this.changePasswordForm.currentPassword = ''
            this.changePasswordForm.newPassword = ''
            this.changePasswordForm.confirmNewPassword = ''
            this.formToShow = 'LOGIN';
          }

          // muestra mensajes de error
          else if(data === 2) 
            showError(this.$t('CHANGE_PASS_invalidPassword'))
          
          else if(data === 8)
            showError(this.$t('CHANGE_PASS_errorOnChangePassword'))

          else if(data === 9)
            showError(this.$t('CHANGE_PASS_emptyPassword'))
          else if(data === 12)
            showError(this.$t('ERROR_CODE_AUTH_12'))
        });
  },
  onCancelChangePassword(){
    this.loginForm.usuario = ''
    this.loginForm.contrasenia = ''
    this.changePasswordForm.currentPassword = ''
    this.changePasswordForm.newPassword = ''
    this.changePasswordForm.confirmNewPassword = ''
    this.formToShow = 'LOGIN';
  },
  onlyNumbers(event) {
      const charCode = event.keyCode || event.which;
      // Permitir únicamente los caracteres del 0 al 9
      if (charCode < 48 || charCode > 57) {
        event.preventDefault(); // Evita que se ingrese cualquier otro carácter
      }
    },
    submitCode() {
      this.verifyTOTP.code = this.digits.join("");
      if(this.verifyTOTP.code.length !== 6){
        showError(this.$t("TWO_FACTOR_AUTHENTICATION_requiredField"));
        return;
      }
      else{
        const payload = {
          usuario: this.loginForm.usuario,
          codigo: this.verifyTOTP.code
        };
        
        this.$store.dispatch('sesion/validarTOTP', payload)
        .then((data) => {
          // indico que se terminó de cambiar la contraseña
          if(data !== undefined){
            if(data.EstaAutenticado)
            {
              // muestro mensaje y cierro la modal
              showSuccess(this.$t('TWO_FACTOR_AUTHENTICATION_verifySuccess'))
              this.loginForm.usuario = ''
              this.loginForm.contrasenia = ''
              this.verifyTOTP.code = ''
              this.$router.push({ name: "Home" });
            }
            else if (data.CodigoResultado === 15) {
              this.sesionActiva = data.Sesion;
              this.showSesionActivaModal = true;
              this.formToShow = 'LOGIN';
              this.$refs.title.textContent = this.$t('LOGIN_loginTitle');
            }
            else if(data.CodigoResultado === 9){
              this.verifyTOTP.code = ''
              showError(this.$t('TWO_FACTOR_AUTHENTICATION_verifyError'))
            }
        }
        else{
              this.verifyTOTP.code = ''
              showError(this.$t('TWO_FACTOR_AUTHENTICATION_verifyError'))
            }
      });
      }
    },
    moveToNext(index) {
      if (this.digits[index] && index < this.digits.length - 1) {
        this.$refs.inputs[index + 1].focus();
      }
    },
    moveToPrev(index) {
      if (!this.digits[index] && index > 0) {
        this.$refs.inputs[index - 1].focus();
      }
    },
  },
  computed: mapState({
    sesion: state => state.sesion
  })
};
</script>

<style scoped>
.el-card {
  border-top: 4px solid white !important;
  background-color: var(--main-color) !important;
  box-shadow: 0px 0px 7px grey;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.3s ease;
}
.fade-leave-active {
  transition: opacity 0.3s ease;
  opacity: 0;
}
.el-container.outer {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.loginContainer {
  display: table-cell;
  vertical-align: middle;
}

.loginContainer .el-card {
  margin-left: auto;
  margin-right: auto;
  width: 80% !important;
  max-width: 690px !important;
}

div.title {
  font-size: 30px;
  line-height: 35px;
  text-align: center;
  color: white;
}

.el-form {
  padding: 40px 100px 0px 100px;
}

.el-button {
  width: 100%;
}

.botonContainer {
  margin-bottom: 10px;
}

.mensajeError {
  background-color: #f44336;
  color: white;
  line-height: 22px;
}

.el-form .el-link {
  font-weight: bold;
  text-decoration: underline;
}

.footer {
  display: inline-block;
  width: 100%;
}

.dataFiscalContainer {
  float: left;
}

.contactoContainer {
  float: right;
  padding-top: 35px;
  color: white;
}

.contactoContainer .el-link i {
  margin-right: 10px;
  color: white;
}

.el-radio-group {
  text-align: left;
  width: 100%;
}

.el-radio {
  float: left;
  margin-bottom: 5px;
}

.restablecerMessage {
  margin: 0px;
  margin-bottom: 15px;
  font-size: 14px;
  text-align: left;
}

.resetPassword .usuarioLabel {
  text-align: left;
  color: white;
  font-weight: bold;
}

@media (max-width: 750px) {
  .el-form {
    padding: 20px 20px 0px 20px;
  }

  .botonContainer button.first {
    margin-bottom: 10px;
  }
}
.el-form-verifyTOTP{
  padding: 5px 0px 0px 0px;
}
.el-form-verifyTOTP-container{
  padding: 15px 100px 0px 100px;
}
.code-container {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.code-input {
  width: 50px;
  height: 60px;
  font-size: 30px;
  text-align: center;
  border: 1 px solid #333;
  border-radius: 15px;
  margin: 0px 2px 0px 2px;
}

</style>

<style>
.el-form.resetPassword .el-form-item__content {
  line-height: 22px;
}

.custom-error .el-form-item__error {
  color: white !important; /* Cambia el color a blanco */
}
</style>